/**
 * Date utility functions
 */

export function formatDistanceToNow(date: Date, options?: { addSuffix?: boolean }): string {
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return options?.addSuffix ? 'just now' : '0 minutes';
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return options?.addSuffix ? `${minutes} minutes ago` : `${minutes} minutes`;
  }
  if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return options?.addSuffix ? `${hours} hours ago` : `${hours} hours`;
  }
  const days = Math.floor(seconds / 86400);
  return options?.addSuffix ? `${days} days ago` : `${days} days`;
}
